import React, { Component } from 'react';

import SignIn from './SignIn';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';

import DisclaimerIcon from '../Common/Profile/SvgIcon/DisclaimerIcon';
import NeedHelpIcon from '../Common/Profile/SvgIcon/NeedHelpIcon';
import HomeIndicator from '../Common/Profile/SvgIcon/HomeIndicator';
import ModalFooter from '../Common/Profile/ModalFooter';
import ModalDisclaimer from '../Common/Profile/ModalDisclaimer';
import ModalHelp from '../Common/Profile/ModalHelp';
import InclaimationIcon from '../Common/Profile/SvgIcon/InclaimationIcon';
import QuestionIcon from '../Common/Profile/SvgIcon/QuestionIcon';
import '../Home/Base/styles.css';

const { LOCAL } = window.AppConfig.REDIRECT_URLS;

const SCREEN = {
	SIGN_IN: 'SIGN_IN',
	SIGN_UP: 'SIGN_UP',
	FORGOT_PASSWORD: 'FORGOT_PASSWORD'
};

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_openedScreen: SCREEN.SIGN_IN,
			_typeModal: '',
			_isModalOpen: false
		};
	}

	openSignUpForm = () => {
		this.setState({
			_openedScreen: SCREEN.SIGN_UP
		});
	};

	openSignInForm = () => {
		this.setState({
			_openedScreen: SCREEN.SIGN_IN
		});
	};

	openForgotPasswordScreen = () => {
		this.setState({
			_openedScreen: SCREEN.FORGOT_PASSWORD
		});
	};
	componentDidMount() {
		if (this.props.openAuth === SCREEN.SIGN_IN) {
			this.openSignInForm();
		} else if (this.props.openAuth === SCREEN.SIGN_UP) {
			this.openSignUpForm();
		}
	}

	setTypeModal = e => {
		this.setState({
			_typeModal: e
		});
	};

	setIsModalOpen = () => {
		this.setState({
			_isModalOpen: !this.state._isModalOpen
		});
	};

	render() {
		const Footer = () => {
			return (
				<>
					{/* <div className="profile-footer-icons-container"> */}
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginTop: '20px',
							width: '100%',
							paddingLeft: '40px',
							paddingRight: '40px'
						}}>
						<DisclaimerIcon
							onClick={() => {
								this.setTypeModal('disclaimer');
								this.setIsModalOpen();
							}}
						/>
						<NeedHelpIcon
							onClick={() => {
								this.setTypeModal('needhelp');
								this.setIsModalOpen();
							}}
						/>
					</div>

					<ModalFooter
						open={this.state._isModalOpen}
						typeModal={this.state._typeModal}
						content={
							this.state._typeModal === 'disclaimer' ? (
								<ModalDisclaimer icon={<InclaimationIcon />} />
							) : (
								<ModalHelp
									email="contact@lendami.com.ph"
									number="+639176544580"
									icon={<QuestionIcon />}
								/>
							)
						}
						setIsModalOpen={this.setIsModalOpen}
					/>
				</>
			);
		};
		switch (this.state._openedScreen) {
			case SCREEN.SIGN_UP:
				return (
					<>
						<SignUp
							onCloseWhenLoanExists={this.props.onCloseWhenLoanExists}
							openScreen={this.props.openScreen}
							openSignInForm={this.openSignInForm}
							props={this.props.props}
							setCurrentUser={this.props.setCurrentUser}
							setInitialScreen={this.props.setInitialScreen}
							supportedStates={this.props.supportedStates}
							user={this.props.user}
							footer={<Footer />}
						/>
					</>
				);
			case SCREEN.SIGN_IN:
				return (
					<SignIn
						onCloseWhenLoanExists={this.props.onCloseWhenLoanExists}
						openForgotPasswordScreen={this.openForgotPasswordScreen}
						openScreen={this.props.openScreen}
						openSignUpForm={this.openSignUpForm}
						props={this.props.props}
						setCurrentUser={this.props.setCurrentUser}
						setInitialScreen={this.props.setInitialScreen}
						user={this.props.user}
						footer={<Footer />}
					/>
				);
			case SCREEN.FORGOT_PASSWORD:
				return <ForgotPassword openSignInForm={this.openSignInForm} />;
			default:
				return null;
		}
	}
}

export default index;
